import React from "react";

const Input = ({
  type = "text",
  label,
  name,
  value,
  onChange,
  placeholder,
  required = false,
  disabled = false,
  className = "",
  labelColor = "",
  inputClassName = "",
  accept = type === "file" ? "image/*" : undefined, // Default accept for file inputs
}) => {
  // Handle file input display differently
  const isFileInput = type === "file";
  
  return (
    <div className={`flex flex-col space-y-1 ${className}`}>
      {label && (
        <label className={`text-sm font-medium ${labelColor}`} htmlFor={name}>
          {label}
        </label>
      )}
      
      {isFileInput ? (
        <div className="flex items-center">
          <input
            id={name}
            type="file"
            name={name}
            onChange={onChange}
            accept={accept}
            required={required}
            disabled={disabled}
            className={`hidden ${inputClassName}`}
          />
          <label
            htmlFor={name}
            className="p-2 border-2 border-gray-300 rounded cursor-pointer hover:bg-gray-100"
          >
            Choose File
          </label>
          {value && (
            <span className="ml-2 text-sm">
              {value.name || "File selected"}
            </span>
          )}
        </div>
      ) : (
        <div className="relative w-full">
        <input
          id={name}
          type={type}
          name={name}
          value={typeof value === "boolean" ? undefined : value}
          checked={typeof value === "boolean" ? value : undefined}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
          disabled={disabled}
          className={`p-2 border-b-2 border-gray-300 focus:border-black w-full outline-none ${inputClassName}`}
        />
          {required && (
          <span className="absolute right-2 top-1/2 -translate-y-1/2 text-red-500">*</span>
          )}
        </div>
      )}
    </div>
  );
};

export default Input;